const REPVISITS_CREATOR_TYPE = {
  HIGH_SCHOOL: 'HIGH_SCHOOL',
  HIGHER_ED: 'HIGHER_ED',
};

export default REPVISITS_CREATOR_TYPE;
